export const BUG_ADDED = 'bugAdded';
export const BUG_REMOVE = 'bugRemoved';
